<template>
  <div class="custom-input-group">
    <div
      v-for="(item, index) in nodeMacAddressArr"
      :key="index"
      class="custom-input custom-input-char node-mac-input-char"
      :class="showConnector(index) ? 'has-connector' : ''"
    >
      <input
        v-model="item.character"
        :disabled="disabled ? disabled : item.disabled"
        :id="'node-mac-character' + index"
        :maxlength="1"
        @input="inputFinish(index)"
        @focus="adjust(index)"
        @keydown="inputDirection($event, index)"
        :class="!item.character ? 'no-value-input' : ''"
      />
      <span class="node-mac-connector" v-if="showConnector(index)">:</span>
    </div>
    <div class="helper-text">
      <i class="el-icon-warning mr-5"></i
      ><i>{{ $t('text.please_enter_capital_letters_and_numbers') }}</i>
    </div>
  </div>
</template>

<script>
import { nodeMaceAddressprefix } from '@/const'
export default {
  data() {
    return {
      activeInput: 1,
      nodeMacAddressArr: this.initInput()
    }
  },
  props: {
    value: {
      type: String,
      require: true
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  computed: {
    showConnector() {
      return index => {
        return (
          (index + 1) % 2 === 0 && index !== this.nodeMacAddressArr.length - 1
        )
      }
    }
  },
  watch: {
    value() {
      if (this.value) {
        // The first 6 characters are fixed AC:23:3F, only last 6 characters can be edited
        let value = this.value.split(':').join('')
        value = value.slice(6)
        this.nodeMacAddressArr = [
          { character: nodeMaceAddressprefix.charAt(0), disabled: true },
          { character: nodeMaceAddressprefix.charAt(1), disabled: true },
          { character: nodeMaceAddressprefix.charAt(2), disabled: true },
          { character: nodeMaceAddressprefix.charAt(3), disabled: true },
          { character: nodeMaceAddressprefix.charAt(4), disabled: true },
          { character: nodeMaceAddressprefix.charAt(5), disabled: true },
          { character: value.charAt(0), disabled: false },
          { character: value.charAt(1), disabled: false },
          { character: value.charAt(2), disabled: false },
          { character: value.charAt(3), disabled: false },
          { character: value.charAt(4), disabled: false },
          { character: value.charAt(5), disabled: false }
        ]
      } else {
        this.nodeMacAddressArr = this.initInput()
      }
    }
  },
  methods: {
    initInput() {
      return [
        { character: nodeMaceAddressprefix.charAt(0), disabled: true },
        { character: nodeMaceAddressprefix.charAt(1), disabled: true },
        { character: nodeMaceAddressprefix.charAt(2), disabled: true },
        { character: nodeMaceAddressprefix.charAt(3), disabled: true },
        { character: nodeMaceAddressprefix.charAt(4), disabled: true },
        { character: nodeMaceAddressprefix.charAt(5), disabled: true },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false }
      ]
    },
    adjust(index) {
      let dom = document.getElementById('node-mac-character' + this.activeInput)
      if (index !== this.activeInput && dom) {
        dom.focus()
      }
    },
    inputDirection(event, index) {
      let val = this.nodeMacAddressArr[index].character
      // Fallback key processing
      if (event.keyCode == 8 && val == '') {
        // Recalibrate
        this.activeInput = index - 1
        let dom = document.getElementById(
          'node-mac-character' + this.activeInput
        )
        if (dom) dom.focus()
      }
      if (event.keyCode != 8 && val != '') {
        this.activeInput = index + 1
        let dom = document.getElementById(
          'node-mac-character' + this.activeInput
        )
        if (dom) dom.focus()
      }
    },
    // The input boxes are interconnected
    inputFinish(index) {
      let specialRule = new RegExp(
        "[`~!@#$^&*()=_|+%{}':;',\\[\\].<>/?~@#￥……&*|{}]"
      )
      let str = this.nodeMacAddressArr[index].character
      if (specialRule.test(str)) {
        this.nodeMacAddressArr[index].character = ''
        return false
      }
      let val = this.nodeMacAddressArr[index].character

      // Automatically convert to uppercase
      this.nodeMacAddressArr.splice(index, 1, {
        character: val.toUpperCase(),
        disabled: false
      })

      // Automatically focus to the next input box
      this.activeInput = val ? index + 1 : index - 1
      let dom = document.getElementById('node-mac-character' + this.activeInput)
      if (dom) dom.focus()
      this.$emit('nodeMacAddressChange', this.nodeMacAddressArr)
    }
  }
}
</script>
